import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
const apiUrl = process.env.REACT_APP_BASEURL;

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

function ShippingBlock(props) {

  const [defaultMethod, setDefaultMethod] = useState(null);
  const [defaultTerms, setDefaultTerms] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const getDefaultMethod = () => {
    try {
      axios.get(apiUrl + `/api/Users/GetDefaultShippingMethod`, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + props.token.token
        },
      })
        .then((response) => {
          // console.log("Shipping Block Line 22 defaultMethod:", response.data)
          setDefaultMethod({ shipmthd: response.data });
          props.setShippingMethod(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const getShippingMethods = () => {
    try {
      axios.get(apiUrl + `/api/Shipping/GetShippingMethods`, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + props.token.token
        },
      })
        .then((response) => {
          if (!Array.isArray(response.data)) {
            setShippingMethods([response.data]);
          } else {
            setShippingMethods(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  }

  const getDefaultPaymentTerms = () => {
    try {
      axios.get(apiUrl + `/api/Users/GetDefaultPaymentTerms`, {
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json",
          'Authorization': 'Bearer ' + props.token.token
        },
      })
        .then((response) => {
          // console.log("get payment terms data:", response.data);
          setDefaultTerms(response.data);
          props.setPaymentMethod(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
    // console.log("Default Terms: ", defaultTerms);
  }



  let headers = new Headers({
    "Accept": "application/json",
    "Content-Type": "application/json",
    'Authorization': 'Bearer ' + props.token.token
  });

  const [paymentTerms, setPaymentTerms] = useState([{ pymtrmid: "QUOTE ONLY" }]);

  const handleShippingChange = (event) => {
    // console.log('Shipping method ' + JSON.stringify(event.target.value));
    props.setShippingMethod(event.target.value);
    setDefaultMethod(event.target.value);
  }

  const handleTermsChange = (event) => {
    // console.log('Selected Payment Term ' + JSON.stringify(event.target.value));
    props.setPaymentMethod(event.target.value);
  }

  const [shippingMethods, setShippingMethods] = useState();

  const updateInputValue = (evt) => {
    // console.log("PO Changed");
    props.setCustomerPO(evt.target.value);
  }

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files); // Convert FileList to array
    setSelectedFiles(files); // Update state with the selected files
  };


  useEffect(() => {
    getShippingMethods();
    getDefaultMethod();
    getDefaultPaymentTerms();

  }, []);

  useEffect(() => {
    if (defaultTerms) {
      setPaymentTerms([{ pymtrmid: defaultTerms }, { pymtrmid: "QUOTE ONLY" }]);
      props.setPaymentMethod(defaultTerms);
    } else { setPaymentTerms([]) }
  }, [defaultTerms]);



  const renderShipMethods = () => {
    if (shippingMethods) {
      return (
        <select id=""
          onChange={(event) => handleShippingChange(event)} defaultValue={defaultMethod ? defaultMethod.shipmthd : "Select Shipping Method"} >
          {shippingMethods.map((method) => (<option key={method.shipmthd} value={method.shipmthd}>{method.shipmthd}</option>))}
        </select>
      )
    }
  };

  const renderPaymentTerms = () => {
    return (
      <select id="comboMethod2"
        defaultValue={defaultTerms === null ? "Select Payment" : defaultTerms}
        onChange={(event) => handleTermsChange(event)} >
        {paymentTerms.map((terms) => { return <option key={terms.pymtrmid} value={terms.pymtrmid}>{terms.pymtrmid}</option> })}
      </select>
    )
  };

  const renderCustomerPO = () => {
    if (props.paymentMethod === "QUOTE ONLY") {
      return (<h1>You Are Requesting A Quote</h1>)
    } else {
      return (
        <>
          <input type="text" className='w-[100%] ' value={props.customerPO} onChange={evt => updateInputValue(evt)} />
        </>
      )
    }
  }


  return (
    <div className="bg-white p-4 rounded-lg shadow-lg space-y-2 max-w-xl ">
    {/* Shipping Method & Carrier */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-gray-700">Shipping Method</label>
        <div className="border p-2 rounded-md">{renderShipMethods()}</div>
      </div>
  
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-gray-700">Carrier</label>
        <div className="border p-2 rounded-md">{renderShipMethods()}</div>
      </div>
    </div>
  
    {/* Payment Terms & Customer PO */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <p className="text-sm font-semibold text-gray-700">Payment Terms</p>
        <p className="text-sm text-black-600 bg-gray-300">2% 10/Net 30</p>
      </div>
  
      <div className="flex flex-col">
        <label className="text-sm font-semibold text-gray-700">Customer PO</label>
        <div className=" p-2 border rounded-md">{renderCustomerPO()}</div>
      </div>
    </div>
  
    {/* Account # Input */}
    <div className="flex flex-col">
      <label className="text-sm font-semibold text-gray-700">Account #</label>
      <input
        className="w-full p-2 border rounded-md text-sm mt-1 focus:ring focus:ring-blue-300"
        type="text"
      />
    </div>
  
    {/* File Upload Section */}
    <div className="flex flex-col items-center p-4 rounded-md">
      <Button
        className="w-full md:w-48 h-10"
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={<CloudUploadIcon />}
      >
        Upload Files
        <VisuallyHiddenInput type="file" onChange={handleFileChange} multiple />
      </Button>
  
      {selectedFiles.length > 0 && (
        <div className="mt-2">
          <p className="text-center font-bold text-sm">Selected Files:</p>
          <ul className="text-xs text-gray-600 mt-1">
            {selectedFiles.map((file, index) => (
              <li key={index}>{file.name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  </div>
  
  );
}
export default ShippingBlock;